export default __webpack_public_path__ + "static/orgs-MR-1fa4a706acc90534947719332eab0531.png";